import { appFaultNotification } from "@/core/modules/appFault/notification/appFaultNotification";
import { cloudFaultNotification } from "@/core/modules/cloudFault/notification/cloudFaultNotification";
import { testNotification } from "@/core/modules/notification/modules/testNotification";
import { userCreatedNotification } from "@/core/modules/user/notification/userCreatedNotification";

export const coreNotificationModules = [appFaultNotification, cloudFaultNotification, testNotification, userCreatedNotification];
